import HomeClasses from './home-classes';
export default HomeClasses;

